import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Icon } from '@ui-kit';
import { RatingItem } from './RatingItem';
import SortIcon from '@ui-kit/icons/code-gray500.svg';
import ChervonIcon from '@ui-kit/icons/chevron-sm-gray500.svg';

const RatingList = ({ items, currentSort, onSortChange, ageMonths, isPreview = false, selectedId = null, onSelect = () => {}, onToggleLike = () => {} }) => {

  // В витрине (нет доступа adobe) сортировка выключена: бэкенд всё равно отдаёт фиксированные
  // 4 записи по updatedAt, поэтому и стрелки, и клик по заголовку только вводили бы в заблуждение.
  const renderSortIcon = (field) => {
    if (isPreview) return null;
    if (currentSort.sortBy !== field) return <Icon src={SortIcon} />;
    return currentSort.sortOrder === 'desc'
      ? <Icon src={ChervonIcon} />
      : <Icon src={ChervonIcon} styles={{ transform: 'rotate(180deg)' }} />;
  };

  const handleSort = (field) => (isPreview ? undefined : onSortChange(field));

  return (
    <div className="rating-table-wrapper">
      <table className={`rating-table${isPreview ? ' preview' : ''}`}>
        <thead>
          <tr>
            <th onClick={() => handleSort('updatedAt')}><div className="th-content"><FormattedMessage id="rating.table.update" defaultMessage="Update" /> {renderSortIcon('updatedAt')}</div></th>
            <th
              onClick={() => handleSort('keyword')}
            ><div className="th-content"><FormattedMessage id="rating.table.keyword" defaultMessage="Keyword" /> {renderSortIcon('keyword')}</div></th>
            {/* col-* — метки для адаптива: на узких экранах колонки прячутся по очереди
                (density → level → type), см. media-запросы в rating.scss */}
            <th className="col-type"><div className="th-content"><FormattedMessage id="rating.table.type" defaultMessage="Type" /></div></th>
            <th
              onClick={() => handleSort('totalResults')}
            ><div className="th-content"><FormattedMessage id="rating.table.results" defaultMessage="Results" /> {renderSortIcon('totalResults')}</div></th>
            {/* Порог месяцев прямо в заголовке: сама по себе цифра «40%» ни о чём не говорит,
                а тянуться глазами к ползунку в сайдбаре при чтении таблицы неудобно.
                Сортируем по 'age' — бэкенд разворачивает это в тот же порог, что и фильтр. */}
            <th
              onClick={() => handleSort('age')}
            ><div className="th-content"><FormattedMessage id="rating.table.fresh" defaultMessage="Fresh {months}m" values={{ months: ageMonths }} /> {renderSortIcon('age')}</div></th>
            <th
              onClick={() => handleSort('score')}
            ><div className="th-content"><FormattedMessage id="rating.table.quality" defaultMessage="Quality" /> {renderSortIcon('score')}</div></th>
            <th className="col-level"><div className="th-content"><FormattedMessage id="rating.table.level" defaultMessage="Level" /></div></th>
            <th
              onClick={() => handleSort('averageRating')}
            ><div className="th-content"><FormattedMessage id="rating.table.average" defaultMessage="Average" /> {renderSortIcon('averageRating')}</div></th>
            <th className="col-density"><div className="th-content"><FormattedMessage id="rating.table.density" defaultMessage="Density" /></div></th>
            <th
              onClick={() => handleSort('likes')}
            ><div className="th-content"><FormattedMessage id="rating.table.likes" defaultMessage="Likes" /> {renderSortIcon('likes')}</div></th>
          </tr>
        </thead>
        <tbody>
          {items.length === 0 ? (
            <tr>
              <td colSpan="10" className="no-data"><FormattedMessage id="rating.table.empty" defaultMessage="No ratings found" /></td>
            </tr>
          ) : (
            items.map((item) => (
              <RatingItem
                key={item.id}
                item={item}
                ageMonths={ageMonths}
                isSelected={item.id === selectedId}
                isPreview={isPreview}
                onSelect={onSelect}
                onToggleLike={onToggleLike}
              />
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default RatingList;

/*
rating = [
  {
    "id": 1035,
    "url": "https://stock.adobe.com/search?filters%5Bcontent_type%3Aphoto%5D=0&filters%5Bcontent_type%3Aillustration%5D=0&filters%5Bcontent_type%3Azip_vector%5D=1&filters%5Bcontent_type%3Avideo%5D=0&filters%5Bgentech%5D=exclude&filters%5Bcontent_type%3Aimage%5D=1&filters%5Binclude_stock_enterprise%5D=1&filters%5Bcontent_type%3Atemplate%5D=0&filters%5Bcontent_type%3A3d%5D=0&order=relevance&price%5B%24%5D=1&k=background+&limit=100&search_page=1&search_type=filter-select&acp=&aco=background+&get_facets=1",
    "keyword": "background",
    "contentType": "Vectors",
    "totalResults": null,
    "score": 487,
    "level": "⭐⭐⭐⭐⭐",
    "total": 100,
    "averageRating": 109,
    "topDensity": 77,
    "eliteDensity": 49,
    "countOrdinary": 10,
    "countGood": 13,
    "countStrong": 18,
    "countTop": 10,
    "countSuperTop": 49,
    "percentOrdinary": 10,
    "percentGood": 13,
    "percentStrong": 18,
    "percentTop": 10,
    "percentSuperTop": 49,
    "createdAt": "2026-08-07T08:17:07.000Z",
    "updatedAt": "2026-08-07T08:17:07.000Z"
  },
  {
    "id": 1026,
    "url": "https://stock.adobe.com/search/images?filters%5Bcontent_type%3Aphoto%5D=1&filters%5Bcontent_type%3Aillustration%5D=1&filters%5Bcontent_type%3Azip_vector%5D=1&filters%5Bgentech%5D=exclude&filters%5Bcontent_type%3Aimage%5D=1&k=water+wave&order=relevance&price%5B%24%5D=1&limit=100&search_page=1&search_type=usertyped&acp=&aco=water+wave&get_facets=1",
    "keyword": "water wave",
    "contentType": "All",
    "totalResults": null,
    "score": 472,
    "level": "⭐⭐⭐⭐⭐",
    "total": 100,
    "averageRating": 101,
    "topDensity": 69,
    "eliteDensity": 50,
    "countOrdinary": 20,
    "countGood": 11,
    "countStrong": 13,
    "countTop": 6,
    "countSuperTop": 50,
    "percentOrdinary": 20,
    "percentGood": 11,
    "percentStrong": 13,
    "percentTop": 6,
    "percentSuperTop": 50,
    "createdAt": "2026-08-07T08:13:03.000Z",
    "updatedAt": "2026-08-07T08:13:03.000Z"
  },
  {
    "id": 541,
    "url": "https://stock.adobe.com/search/images?filters%5Bcontent_type%3Azip_vector%5D=1&filters%5Bgentech%5D=exclude&filters%5Bcontent_type%3Aimage%5D=1&k=Blue+abstract+background&order=relevance&price%5B%24%5D=1&limit=100&search_page=1&load_type=page&search_type=usertyped&acp=&aco=Blue+abstract+background&get_facets=1",
    "keyword": "blue abstract background",
    "contentType": "Vectors",
    "totalResults": null,
    "score": 463,
    "level": "⭐⭐⭐⭐⭐",
    "total": 100,
    "averageRating": 111,
    "topDensity": 67,
    "eliteDensity": 47,
    "countOrdinary": 13,
    "countGood": 20,
    "countStrong": 9,
    "countTop": 11,
    "countSuperTop": 47,
    "percentOrdinary": 13,
    "percentGood": 20,
    "percentStrong": 9,
    "percentTop": 11,
    "percentSuperTop": 47,
    "createdAt": "2026-08-06T06:08:40.000Z",
    "updatedAt": "2026-08-07T07:55:09.000Z"
  },
  {
    "id": 710,
    "url": "https://stock.adobe.com/search/images?filters%5Bcontent_type%3Aphoto%5D=1&filters%5Bcontent_type%3Aillustration%5D=1&filters%5Bcontent_type%3Azip_vector%5D=1&filters%5Bgentech%5D=exclude&filters%5Bcontent_type%3Aimage%5D=1&k=background+Snowflake&order=relevance&price%5B%24%5D=1&limit=100&search_page=1&search_type=usertyped&acp=&aco=background+Snowflake&get_facets=1",
    "keyword": "background snowflake",
    "contentType": "All",
    "totalResults": null,
    "score": 434,
    "level": "⭐⭐⭐⭐⭐",
    "total": 100,
    "averageRating": 106,
    "topDensity": 61,
    "eliteDensity": 47,
    "countOrdinary": 28,
    "countGood": 11,
    "countStrong": 10,
    "countTop": 4,
    "countSuperTop": 47,
    "percentOrdinary": 28,
    "percentGood": 11,
    "percentStrong": 10,
    "percentTop": 4,
    "percentSuperTop": 47,
    "createdAt": "2026-08-06T13:44:50.000Z",
    "updatedAt": "2026-08-06T13:44:50.000Z"
  },
  {
    "id": 709,
    "url": "https://stock.adobe.com/search/images?filters%5Bcontent_type%3Aphoto%5D=1&filters%5Bcontent_type%3Aillustration%5D=1&filters%5Bcontent_type%3Azip_vector%5D=1&filters%5Bgentech%5D=exclude&filters%5Bcontent_type%3Aimage%5D=1&k=snowflake+background&order=relevance&price%5B%24%5D=1&limit=100&search_page=1&search_type=autosuggest&acp=1&aco=snowflake+&get_facets=1",
    "keyword": "snowflake background",
    "contentType": "All",
    "totalResults": null,
    "score": 408,
    "level": "⭐⭐⭐⭐⭐",
    "total": 100,
    "averageRating": 101,
    "topDensity": 58,
    "eliteDensity": 44,
    "countOrdinary": 31,
    "countGood": 11,
    "countStrong": 10,
    "countTop": 4,
    "countSuperTop": 44,
    "percentOrdinary": 31,
    "percentGood": 11,
    "percentStrong": 10,
    "percentTop": 4,
    "percentSuperTop": 44,
    "createdAt": "2026-08-06T13:44:15.000Z",
    "updatedAt": "2026-08-06T13:45:37.000Z"
  },
  {
    "id": 81,
    "url": "https://stock.adobe.com/search/images?filters%5Bcontent_type%3Aphoto%5D=1&filters%5Bcontent_type%3Aillustration%5D=1&filters%5Bcontent_type%3Azip_vector%5D=1&filters%5Bgentech%5D=exclude&filters%5Bcontent_type%3Aimage%5D=1&k=floral+frame++invitation&order=relevance&price%5B%24%5D=1&limit=100&search_page=1&search_type=usertyped&acp=&aco=floral+frame++invitation&get_facets=1",
    "keyword": "floral frame  invitation",
    "contentType": "All",
    "totalResults": null,
    "score": 374,
    "level": "⭐⭐⭐⭐⭐",
    "total": 100,
    "averageRating": 85,
    "topDensity": 62,
    "eliteDensity": 33,
    "countOrdinary": 30,
    "countGood": 8,
    "countStrong": 10,
    "countTop": 19,
    "countSuperTop": 33,
    "percentOrdinary": 30,
    "percentGood": 8,
    "percentStrong": 10,
    "percentTop": 19,
    "percentSuperTop": 33,
    "createdAt": "2026-07-10T11:54:29.000Z",
    "updatedAt": "2026-07-21T10:37:19.000Z"
  },
  {
    "id": 1103,
    "url": "https://stock.adobe.com/search/images?filters%5Bcontent_type%3Aphoto%5D=1&filters%5Bcontent_type%3Aillustration%5D=1&filters%5Bcontent_type%3Azip_vector%5D=1&filters%5Bgentech%5D=exclude&filters%5Binclude_stock_enterprise%5D=1&filters%5Bcontent_type%3Aimage%5D=1&k=Hand+drawn+arrow&order=relevance&price%5B%24%5D=1&limit=100&search_page=1&search_type=usertyped&acp=&aco=Hand+drawn+arrow&get_facets=1",
    "keyword": "hand drawn arrow",
    "contentType": "All",
    "totalResults": null,
    "score": 362,
    "level": "⭐⭐⭐⭐⭐",
    "total": 100,
    "averageRating": 107,
    "topDensity": 53,
    "eliteDensity": 39,
    "countOrdinary": 32,
    "countGood": 15,
    "countStrong": 12,
    "countTop": 2,
    "countSuperTop": 39,
    "percentOrdinary": 32,
    "percentGood": 15,
    "percentStrong": 12,
    "percentTop": 2,
    "percentSuperTop": 39,
    "createdAt": "2026-08-07T08:48:20.000Z",
    "updatedAt": "2026-08-07T08:48:20.000Z"
  },
  {
    "id": 711,
    "url": "https://stock.adobe.com/search/images?filters%5Bcontent_type%3Azip_vector%5D=1&filters%5Bcontent_type%3Aimage%5D=1&filters%5Bgentech%5D=exclude&k=+star+shape&order=relevance&price%5B%24%5D=1&limit=100&search_page=1&search_type=usertyped&acp=&aco=+star+shape&get_facets=1&asset_id=1964442075",
    "keyword": "star shape",
    "contentType": "Vectors",
    "totalResults": null,
    "score": 342,
    "level": "⭐⭐⭐⭐⭐",
    "total": 100,
    "averageRating": 95,
    "topDensity": 56,
    "eliteDensity": 33,
    "countOrdinary": 29,
    "countGood": 15,
    "countStrong": 14,
    "countTop": 9,
    "countSuperTop": 33,
    "percentOrdinary": 29,
    "percentGood": 15,
    "percentStrong": 14,
    "percentTop": 9,
    "percentSuperTop": 33,
    "createdAt": "2026-08-06T13:45:00.000Z",
    "updatedAt": "2026-08-06T13:45:18.000Z"
  },
  {
    "id": 672,
    "url": "https://stock.adobe.com/search/images?filters%5Bcontent_type%3Aphoto%5D=1&filters%5Bcontent_type%3Aillustration%5D=1&filters%5Bcontent_type%3Azip_vector%5D=1&filters%5Bgentech%5D=exclude&filters%5Bcontent_type%3Aimage%5D=1&k=retro+sticker+vintage&order=relevance&price%5B%24%5D=1&limit=100&search_page=1&search_type=usertyped&acp=&aco=retro+sticker+vintage&get_facets=1&asset_id=1492964670",
    "keyword": "retro sticker vintage",
    "contentType": "All",
    "totalResults": null,
    "score": 338,
    "level": "⭐⭐⭐⭐⭐",
    "total": 100,
    "averageRating": 86,
    "topDensity": 52,
    "eliteDensity": 34,
    "countOrdinary": 24,
    "countGood": 24,
    "countStrong": 12,
    "countTop": 6,
    "countSuperTop": 34,
    "percentOrdinary": 24,
    "percentGood": 24,
    "percentStrong": 12,
    "percentTop": 6,
    "percentSuperTop": 34,
    "createdAt": "2026-08-06T10:22:25.000Z",
    "updatedAt": "2026-08-06T10:25:32.000Z"
  },
  {
    "id": 708,
    "url": "https://stock.adobe.com/search/images?filters%5Bcontent_type%3Aphoto%5D=1&filters%5Bcontent_type%3Aillustration%5D=1&filters%5Bcontent_type%3Azip_vector%5D=1&filters%5Bcontent_type%3Avideo%5D=0&filters%5Bcontent_type%3Atemplate%5D=0&filters%5Bcontent_type%3A3d%5D=0&filters%5Bcontent_type%3Aaudio%5D=0&filters%5Bgentech%5D=exclude&filters%5Binclude_stock_enterprise%5D=0&filters%5Bis_editorial%5D=0&filters%5Bcontent_type%3Aimage%5D=1&filters%5Bfree_collection%5D=0&k=Snowflake+background+transparent&order=relevance&price%5B%24%5D=1&search_page=1&search_type=usertyped&acp=&aco=Snowflake+background+transparent&get_facets=1",
    "keyword": "snowflake background transparent",
    "contentType": "All",
    "totalResults": null,
    "score": 327,
    "level": "⭐⭐⭐⭐⭐",
    "total": 100,
    "averageRating": 85,
    "topDensity": 57,
    "eliteDensity": 31,
    "countOrdinary": 27,
    "countGood": 16,
    "countStrong": 18,
    "countTop": 8,
    "countSuperTop": 31,
    "percentOrdinary": 27,
    "percentGood": 16,
    "percentStrong": 18,
    "percentTop": 8,
    "percentSuperTop": 31,
    "createdAt": "2026-08-06T13:44:02.000Z",
    "updatedAt": "2026-08-06T13:44:02.000Z"
  },
  {
    "id": 508,
    "url": "https://stock.adobe.com/search/images?filters%5Bcontent_type%3Azip_vector%5D=1&filters%5Bgentech%5D=exclude&filters%5Bcontent_type%3Aimage%5D=1&k=Snowflake+background+white&order=relevance&price%5B%24%5D=1&limit=100&search_page=1&search_type=usertyped&acp=&aco=Snowflake+background+white&get_facets=1",
    "keyword": "snowflake background white",
    "contentType": "Vectors",
    "totalResults": 560463,
    "score": 325,
    "level": "⭐⭐⭐⭐⭐",
    "total": 99,
    "averageRating": 85,
    "topDensity": 52,
    "eliteDensity": 33,
    "countOrdinary": 37,
    "countGood": 11,
    "countStrong": 13,
    "countTop": 5,
    "countSuperTop": 33,
    "percentOrdinary": 37.4,
    "percentGood": 11.1,
    "percentStrong": 13.1,
    "percentTop": 5.1,
    "percentSuperTop": 33.3,
    "createdAt": "2026-08-05T21:45:16.000Z",
    "updatedAt": "2026-08-07T20:27:42.000Z"
  },
  {
    "id": 1260,
    "url": "https://stock.adobe.com/search/images?filters%5Bcontent_type%3Azip_vector%5D=1&filters%5Bgentech%5D=exclude&filters%5Bcontent_type%3Aimage%5D=1&k=business+calendar&order=relevance&price%5B%24%5D=1&limit=100&search_page=1&search_type=usertyped&acp=&aco=business+calendar&get_facets=1",
    "keyword": "business calendar",
    "contentType": "Vectors",
    "totalResults": null,
    "score": 311,
    "level": "⭐⭐⭐⭐⭐",
    "total": 99,
    "averageRating": 76,
    "topDensity": 45,
    "eliteDensity": 32,
    "countOrdinary": 43,
    "countGood": 11,
    "countStrong": 7,
    "countTop": 6,
    "countSuperTop": 32,
    "percentOrdinary": 43.4,
    "percentGood": 11.1,
    "percentStrong": 7.1,
    "percentTop": 6.1,
    "percentSuperTop": 32.3,
    "createdAt": "2026-08-07T09:41:36.000Z",
    "updatedAt": "2026-08-07T09:45:08.000Z"
  },
  {
    "id": 1456,
    "url": "https://stock.adobe.com/search/images?filters%5Bcontent_type%3Azip_vector%5D=1&filters%5Bgentech%5D=exclude&filters%5Bcontent_type%3Aimage%5D=1&k=ai+background&order=relevance&price%5B%24%5D=1&limit=100&search_type=usertyped&search_page=1&acp=&aco=ai+background&get_facets=1",
    "keyword": "ai background",
    "contentType": "Vectors",
    "totalResults": null,
    "score": 310,
    "level": "⭐⭐⭐⭐⭐",
    "total": 100,
    "averageRating": 84,
    "topDensity": 49,
    "eliteDensity": 30,
    "countOrdinary": 29,
    "countGood": 22,
    "countStrong": 11,
    "countTop": 8,
    "countSuperTop": 30,
    "percentOrdinary": 29,
    "percentGood": 22,
    "percentStrong": 11,
    "percentTop": 8,
    "percentSuperTop": 30,
    "createdAt": "2026-08-07T12:54:23.000Z",
    "updatedAt": "2026-08-07T12:54:23.000Z"
  },
  {
    "id": 14,
    "url": "https://stock.adobe.com/search?k=torn+paper+border&search_type=usertyped&filters%5Bgentech%5D=exclude&order=relevance&price%5B%24%5D=1&filters%5Bcontent_type%3Aphoto%5D=1&filters%5Bcontent_type%3Aillustration%5D=1&filters%5Bcontent_type%3Azip_vector%5D=1",
    "keyword": "torn paper border",
    "contentType": "All",
    "totalResults": null,
    "score": 309,
    "level": "⭐⭐⭐⭐⭐",
    "total": 99,
    "averageRating": 83,
    "topDensity": 46,
    "eliteDensity": 31,
    "countOrdinary": 38,
    "countGood": 15,
    "countStrong": 8,
    "countTop": 7,
    "countSuperTop": 31,
    "percentOrdinary": 38.4,
    "percentGood": 15.2,
    "percentStrong": 8.1,
    "percentTop": 7.1,
    "percentSuperTop": 31.3,
    "createdAt": "2026-07-05T21:52:25.000Z",
    "updatedAt": "2026-08-07T08:07:57.000Z"
  },
  {
    "id": 669,
    "url": "https://stock.adobe.com/search/images?k=retro+sticker&search_type=usertyped&filters%5Bgentech%5D=exclude&filters%5Bcontent_type%3Aphoto%5D=1&filters%5Bcontent_type%3Aillustration%5D=1&filters%5Bcontent_type%3Azip_vector%5D=1&order=relevance&price%5B%24%5D=1&asset_id=1612518399",
    "keyword": "retro sticker",
    "contentType": "All",
    "totalResults": null,
    "score": 306,
    "level": "⭐⭐⭐⭐⭐",
    "total": 100,
    "averageRating": 80,
    "topDensity": 44,
    "eliteDensity": 33,
    "countOrdinary": 34,
    "countGood": 22,
    "countStrong": 10,
    "countTop": 1,
    "countSuperTop": 33,
    "percentOrdinary": 34,
    "percentGood": 22,
    "percentStrong": 10,
    "percentTop": 1,
    "percentSuperTop": 33,
    "createdAt": "2026-08-06T10:20:27.000Z",
    "updatedAt": "2026-08-06T10:21:22.000Z"
  },
  {
    "id": 1707,
    "url": "https://stock.adobe.com/search/images?filters%5Bcontent_type%3Aphoto%5D=1&filters%5Bcontent_type%3Aillustration%5D=1&filters%5Bcontent_type%3Azip_vector%5D=1&filters%5Bgentech%5D=exclude&filters%5Binclude_stock_enterprise%5D=1&filters%5Bcontent_type%3Aimage%5D=1&k=vector+shape+flower+&order=relevance&price%5B%24%5D=1&limit=100&search_page=1&search_type=usertyped&acp=&aco=vector+shape+flower+&get_facets=1",
    "keyword": "vector shape flower",
    "contentType": "All",
    "totalResults": 2058713,
    "score": 299,
    "level": "⭐⭐⭐⭐⭐",
    "total": 99,
    "averageRating": 83,
    "topDensity": 48,
    "eliteDensity": 27,
    "countOrdinary": 37,
    "countGood": 14,
    "countStrong": 8,
    "countTop": 13,
    "countSuperTop": 27,
    "percentOrdinary": 37.4,
    "percentGood": 14.1,
    "percentStrong": 8.1,
    "percentTop": 13.1,
    "percentSuperTop": 27.3,
    "createdAt": "2026-08-07T17:59:10.000Z",
    "updatedAt": "2026-08-07T17:59:49.000Z"
  },
  {
    "id": 480,
    "url": "https://stock.adobe.com/search?filters%5Bcontent_type%3Azip_vector%5D=1&filters%5Bgentech%5D=exclude&filters%5Bcontent_type%3Aimage%5D=1&order=relevance&k=snow+banner&limit=100&search_page=1&search_type=usertyped&acp=&aco=snow+banner&price%5B%24%5D=1&get_facets=1",
    "keyword": "snow banner",
    "contentType": "Vectors",
    "totalResults": null,
    "score": 294,
    "level": "⭐⭐⭐⭐⭐",
    "total": 100,
    "averageRating": 79,
    "topDensity": 42,
    "eliteDensity": 31,
    "countOrdinary": 45,
    "countGood": 13,
    "countStrong": 7,
    "countTop": 4,
    "countSuperTop": 31,
    "percentOrdinary": 45,
    "percentGood": 13,
    "percentStrong": 7,
    "percentTop": 4,
    "percentSuperTop": 31,
    "createdAt": "2026-08-05T21:14:25.000Z",
    "updatedAt": "2026-08-05T21:14:25.000Z"
  },
  {
    "id": 1814,
    "url": "https://stock.adobe.com/search/images?filters%5Bcontent_type%3Aphoto%5D=1&filters%5Bcontent_type%3Aillustration%5D=1&filters%5Bcontent_type%3Azip_vector%5D=1&filters%5Bcontent_type%3Avideo%5D=0&filters%5Bcontent_type%3Atemplate%5D=0&filters%5Bcontent_type%3A3d%5D=0&filters%5Bcontent_type%3Aaudio%5D=0&filters%5Bgentech%5D=exclude&filters%5Binclude_stock_enterprise%5D=0&filters%5Bis_editorial%5D=0&filters%5Bcontent_type%3Aimage%5D=1&k=calendar+icon&order=relevance&price%5B%24%5D=1&search_page=1&search_type=usertyped&acp=&aco=calendar+icon&get_facets=1",
    "keyword": "calendar icon",
    "contentType": "All",
    "totalResults": 1600449,
    "score": 289,
    "level": "⭐⭐⭐⭐⭐",
    "total": 99,
    "averageRating": 76,
    "topDensity": 46,
    "eliteDensity": 29,
    "countOrdinary": 35,
    "countGood": 18,
    "countStrong": 13,
    "countTop": 4,
    "countSuperTop": 29,
    "percentOrdinary": 35.4,
    "percentGood": 18.2,
    "percentStrong": 13.1,
    "percentTop": 4,
    "percentSuperTop": 29.3,
    "createdAt": "2026-08-08T12:57:02.000Z",
    "updatedAt": "2026-08-08T12:58:00.000Z"
  },
  {
    "id": 557,
    "url": "https://stock.adobe.com/search/images?filters%5Bcontent_type%3Azip_vector%5D=1&filters%5Bgentech%5D=exclude&filters%5Bcontent_type%3Aimage%5D=1&order=relevance&price%5B%24%5D=1&limit=100&search_page=1&search_type=usertyped&acp=&aco=Gold+star+background&k=Gold+star+background&get_facets=1",
    "keyword": "gold star background",
    "contentType": "Vectors",
    "totalResults": null,
    "score": 281,
    "level": "⭐⭐⭐⭐⭐",
    "total": 100,
    "averageRating": 82,
    "topDensity": 48,
    "eliteDensity": 28,
    "countOrdinary": 33,
    "countGood": 19,
    "countStrong": 17,
    "countTop": 3,
    "countSuperTop": 28,
    "percentOrdinary": 33,
    "percentGood": 19,
    "percentStrong": 17,
    "percentTop": 3,
    "percentSuperTop": 28,
    "createdAt": "2026-08-06T06:33:27.000Z",
    "updatedAt": "2026-08-06T13:55:17.000Z"
  },
  {
    "id": 1619,
    "url": "https://stock.adobe.com/search/images?filters%5Bcontent_type%3Aphoto%5D=1&filters%5Bcontent_type%3Aillustration%5D=1&filters%5Bcontent_type%3Azip_vector%5D=1&filters%5Bgentech%5D=exclude&filters%5Bcontent_type%3Aimage%5D=1&k=star+texture&order=relevance&price%5B%24%5D=1&limit=100&search_page=1&search_type=usertyped&acp=&aco=star+texture&get_facets=1",
    "keyword": "star texture",
    "contentType": "All",
    "totalResults": 1802877,
    "score": 280,
    "level": "⭐⭐⭐⭐⭐",
    "total": 100,
    "averageRating": 81,
    "topDensity": 43,
    "eliteDensity": 28,
    "countOrdinary": 34,
    "countGood": 23,
    "countStrong": 10,
    "countTop": 5,
    "countSuperTop": 28,
    "percentOrdinary": 34,
    "percentGood": 23,
    "percentStrong": 10,
    "percentTop": 5,
    "percentSuperTop": 28,
    "createdAt": "2026-08-07T14:21:54.000Z",
    "updatedAt": "2026-08-07T14:21:54.000Z"
  }
]
 */